import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import defaultAvatar from 'static/images/default_avatar.png';
import Utils from 'helpers/utils';
// import kamUtil from '@kambria/kambria-util';
import { connectWallet, watchInfo } from 'redux/actions/blockchain.action';
import { changePassword, logInMvp, logOutMvp, verifyBySignIn } from 'redux/actions/user.action';
import './NavProfile.css';
import logout from 'static/images/mvp/logout.png';
import emptyWallet from 'static/images/mvp/empty-wallet.png';
import arrowRight2Light from 'static/images/mvp/arrow-right-2-light.png';
import passwordChange from 'static/images/mvp/password-change.svg';
import Web3 from 'web3';
import { I18n } from '../../../helpers/i18n';
import CustomAccountLogo from './CustomAccontLogo';
import { Modal as ModalPopup } from 'react-bootstrap';
import arrowBackIcon from '../../../static/images/mvp/black-arrow-left.png';
import {
  FormField,
  FormSection, Input, InputLabel,
  SectionBody,
  SectionFooter,
} from 'aws-amplify-react/lib/Amplify-UI/Amplify-UI-Components-React';
import { formTheme } from '../../mvpAuth/ThemeSignIn';
import warning from '../../../static/images/mvp/warning.png';
import { toast } from 'react-toastify';

function NavProfile({ blockchain, user, credit, logOutMvp, verifyBySignIn, changePassword }) {
  const [toggle, setToggle] = useState(false);
  const [toggleSenior, setToggleSenior] = useState(false);
  const [passwordChangeModal, setPasswordChangeModal] = useState(false);
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [passwordConfirmError, setPasswordConfirmError] = useState('');
  const [passwordVerify, setPasswordVerify] = useState(false);

  useEffect(() => {
    if (passwordChangeModal === true) {
      setPasswordVerify(false);
      resetInputs()
    }
  }, [passwordChangeModal]);

  const onToggle = () => {
    const { type } = user;
    if (type == 'seniorBuddy') {
      setToggle(!toggle);
    }
    if (type == 'senior') {
      setToggleSenior(!toggleSenior);
    }
  };

  const resetInputs = () => {
    setPasswordConfirmError('');
    setPasswordError('');
    setPassword('');
    setPassword2('')
  }

  const changePasswordGoBack = () => {
    if (passwordVerify) {
      setPasswordVerify(false);
      resetInputs()
    } else {
      togglePasswordChangeModal()
    }
  }

  const togglePasswordChangeModal = () => {
    const bool = passwordChangeModal === true ? false : true;
    if (bool) {
      setToggle(false);
      setToggleSenior(false);
    }
    setPasswordChangeModal(bool)
  }

  const checkPassword = async () => {
    if (!passwordVerify) {
      return verifyBySignIn(user.email, password)
        .then(result => {
          if (result.status !== 'OK') {
            setPasswordError(I18n.t('register_not_match_password'))
          } else {
            setPasswordVerify(true)
            setPasswordError('')
            setPassword('')
          }
        })
    }
    if (password2 !== password) {
      setPasswordConfirmError(I18n.t('repeat_password_match'))
      return
    }
    await changePassword(user.email, password, password2).then(result => {
      if (result.status === 'OK') {
        toast.success(I18n.t('change_password_success_title'), {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: 'colored',
          className: 'toast-success-container toast-success-container-after',
        });
      } else {
        toast.error(I18n.t('something_wrong'), {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          className: 'toast-error-container toast-error-container-after',
          theme: 'colored',
        });
      }
      setPasswordVerify(false)
      setPasswordError('')
      setPassword('')
      setPasswordChangeModal(false)
      setPasswordConfirmError('')
    })
  }

  const onLogout = async () => {
    localStorage.removeItem('pathBeforeSignIn');
    localStorage.removeItem('user-info');
    sessionStorage.removeItem('previousUrl');
    await logOutMvp(user.accessToken).then(() => {
      Utils.removeCookie('_RFT');
      localStorage.removeItem('user-info');
      sessionStorage.removeItem('previousUrl');
    });

    window.location.replace('/');
  };
  const [userWalletID, setuserWalletID] = useState(0);
  // const [userNetworkId, setUserNetworkId] = useState(0);

  const connectMetamask = async () => {
    if (typeof window.ethereum !== 'undefined') {
      try {
        alert(I18n.t('metamask_finish_signin'));
        const web3 = new Web3(window.ethereum);
        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
        const networkId = await web3.eth.net.getId();
        setuserWalletID(accounts[0]);
        //  setUserNetworkId(networkId);
        let tokenContract;
        // Create the token contract instance
        if (networkId === 56) {
          tokenContract = new web3.eth.Contract(tokenABI, tokenAddress);
        } else if (networkId === 1) {
          tokenContract = new web3.eth.Contract(tokenABI2, tokenAddress2);
        } else {
          tokenContract = new web3.eth.Contract(tokenABI, tokenAddress);
        }
        ;
        // Call the balanceOf method on the token contract
        tokenContract.methods.balanceOf(accounts[0]).call().then((balance) => {
          // The balance is returned as a big number, you may need to convert it to a readable format
          setTokenBalance(web3.utils.fromWei(balance, 'ether'));
        }).catch((error) => {
          console.error('Error fetching token balance:', error);
        });
      } catch (error) {
        console.error(error);
      }
    } else {
      alert(I18n.t('metamask_install'));
    }
  };


  useEffect(() => {
    const checkAccounts = async () => {
      // Check if the window.ethereum object is available and connected
      if (window.ethereum) {
        try {
          const connectChecker = await window.ethereum.request({ method: 'eth_accounts' });

          if (connectChecker.length === 0) {
            // No accounts connected, handle it here
            console.log('No accounts connected');
          } else {
            // Accounts are connected, handle it here
            console.log('Connected accounts:', connectChecker);

            const web3 = new Web3(window.ethereum);

            const networkId = await web3.eth.net.getId();
            console.log('window.ethereum.isConnected', window.ethereum._metamask.isUnlocked());
            // Request access to accounts

            setuserWalletID(connectChecker[0]);
            let tokenContract;
            // Create the token contract instance
            if (networkId === 56) {
              tokenContract = new web3.eth.Contract(tokenABI, tokenAddress);
            } else if (networkId === 1) {
              tokenContract = new web3.eth.Contract(tokenABI2, tokenAddress2);
            } else {
              tokenContract = new web3.eth.Contract(tokenABI, tokenAddress);
            }
            ;
            // Call the balanceOf method on the token contract
            tokenContract.methods.balanceOf(connectChecker[0]).call().then((balance) => {
              // The balance is returned as a big number, you may need to convert it to a readable format
              setTokenBalance(web3.utils.fromWei(balance, 'ether'));
            }).catch((error) => {
              console.error('Error fetching token balance:', error);
            });


          }
        } catch (error) {
          // Handle any errors that occur during the request
          console.error('Error retrieving accounts:', error);
        }
      }
    };

    checkAccounts(); // Call the async function inside useEffect
  }, []);

  const { account, kat } = blockchain;
  const balance = (() => {
    // const katAmount = Number(kamUtil.unit.wkat2KAT(kat || 0));
    const katAmount = 0;
    const katBalance = (Math.round((katAmount + Number.EPSILON) * 100) / 100).toFixed(2);
    return `${Utils.formatNumber(katBalance) || 0} KAT`;
  })();
  const { firstName, lastName, name, email, type, wallet } = user;
  const username = `${firstName || ''} ${lastName || ''}`.trim() || name || email;
  const toggleClass = toggle ? 'open' : 'close';
  //const karmaAmount = karma.amount ? `${karma.amount} KARMAS` : '0 KARMA';
  const creditAmount = credit.amount ? credit.amount : 0;

  const tokenAddress = '0x3A9eED92422ABdd7566fbA8C34Bb74b3f656DBb3';
  const tokenAddress2 = '0x14da230d6726C50F759Bc1838717F8CE6373509C';
  //const walletAddress = userWalletID;
  const tokenABI = [{ 'inputs': [], 'stateMutability': 'nonpayable', 'type': 'constructor' }, {
    'anonymous': false,
    'inputs': [{ 'indexed': true, 'internalType': 'address', 'name': 'owner', 'type': 'address' }, {
      'indexed': true,
      'internalType': 'address',
      'name': 'spender',
      'type': 'address',
    }, { 'indexed': false, 'internalType': 'uint256', 'name': 'value', 'type': 'uint256' }],
    'name': 'Approval',
    'type': 'event',
  }, {
    'anonymous': false,
    'inputs': [{
      'indexed': true,
      'internalType': 'address',
      'name': 'previousOwner',
      'type': 'address',
    }, { 'indexed': true, 'internalType': 'address', 'name': 'newOwner', 'type': 'address' }],
    'name': 'OwnershipTransferred',
    'type': 'event',
  }, {
    'anonymous': false,
    'inputs': [{ 'indexed': true, 'internalType': 'bytes32', 'name': 'role', 'type': 'bytes32' }, {
      'indexed': true,
      'internalType': 'bytes32',
      'name': 'previousAdminRole',
      'type': 'bytes32',
    }, { 'indexed': true, 'internalType': 'bytes32', 'name': 'newAdminRole', 'type': 'bytes32' }],
    'name': 'RoleAdminChanged',
    'type': 'event',
  }, {
    'anonymous': false,
    'inputs': [{ 'indexed': true, 'internalType': 'bytes32', 'name': 'role', 'type': 'bytes32' }, {
      'indexed': true,
      'internalType': 'address',
      'name': 'account',
      'type': 'address',
    }, { 'indexed': true, 'internalType': 'address', 'name': 'sender', 'type': 'address' }],
    'name': 'RoleGranted',
    'type': 'event',
  }, {
    'anonymous': false,
    'inputs': [{ 'indexed': true, 'internalType': 'bytes32', 'name': 'role', 'type': 'bytes32' }, {
      'indexed': true,
      'internalType': 'address',
      'name': 'account',
      'type': 'address',
    }, { 'indexed': true, 'internalType': 'address', 'name': 'sender', 'type': 'address' }],
    'name': 'RoleRevoked',
    'type': 'event',
  }, {
    'anonymous': false,
    'inputs': [{ 'indexed': true, 'internalType': 'address', 'name': 'from', 'type': 'address' }, {
      'indexed': true,
      'internalType': 'address',
      'name': 'to',
      'type': 'address',
    }, { 'indexed': false, 'internalType': 'uint256', 'name': 'value', 'type': 'uint256' }],
    'name': 'Transfer',
    'type': 'event',
  }, {
    'inputs': [],
    'name': 'ADMIN_ROLE',
    'outputs': [{ 'internalType': 'bytes32', 'name': '', 'type': 'bytes32' }],
    'stateMutability': 'view',
    'type': 'function',
  }, {
    'inputs': [],
    'name': 'MINTER_ROLE',
    'outputs': [{ 'internalType': 'bytes32', 'name': '', 'type': 'bytes32' }],
    'stateMutability': 'view',
    'type': 'function',
  }, {
    'inputs': [{ 'internalType': 'address', 'name': 'owner', 'type': 'address' }, {
      'internalType': 'address',
      'name': 'spender',
      'type': 'address',
    }],
    'name': 'allowance',
    'outputs': [{ 'internalType': 'uint256', 'name': '', 'type': 'uint256' }],
    'stateMutability': 'view',
    'type': 'function',
  }, {
    'inputs': [{ 'internalType': 'address', 'name': 'spender', 'type': 'address' }, {
      'internalType': 'uint256',
      'name': 'amount',
      'type': 'uint256',
    }], 'name': 'approve', 'outputs': [], 'stateMutability': 'nonpayable', 'type': 'function',
  }, {
    'inputs': [{ 'internalType': 'address', 'name': 'account', 'type': 'address' }],
    'name': 'balanceOf',
    'outputs': [{ 'internalType': 'uint256', 'name': '', 'type': 'uint256' }],
    'stateMutability': 'view',
    'type': 'function',
  }, {
    'inputs': [{ 'internalType': 'uint256', 'name': 'amount', 'type': 'uint256' }],
    'name': 'burn',
    'outputs': [{ 'internalType': 'bool', 'name': '', 'type': 'bool' }],
    'stateMutability': 'nonpayable',
    'type': 'function',
  }, {
    'inputs': [],
    'name': 'decimals',
    'outputs': [{ 'internalType': 'uint8', 'name': '', 'type': 'uint8' }],
    'stateMutability': 'view',
    'type': 'function',
  }, {
    'inputs': [{ 'internalType': 'address', 'name': 'spender', 'type': 'address' }, {
      'internalType': 'uint256',
      'name': 'subtractedValue',
      'type': 'uint256',
    }],
    'name': 'decreaseAllowance',
    'outputs': [{ 'internalType': 'bool', 'name': '', 'type': 'bool' }],
    'stateMutability': 'nonpayable',
    'type': 'function',
  }, {
    'inputs': [],
    'name': 'getOwner',
    'outputs': [{ 'internalType': 'address', 'name': '', 'type': 'address' }],
    'stateMutability': 'view',
    'type': 'function',
  }, {
    'inputs': [{ 'internalType': 'bytes32', 'name': 'role', 'type': 'bytes32' }],
    'name': 'getRoleAdmin',
    'outputs': [{ 'internalType': 'bytes32', 'name': '', 'type': 'bytes32' }],
    'stateMutability': 'view',
    'type': 'function',
  }, {
    'inputs': [{ 'internalType': 'bytes32', 'name': 'role', 'type': 'bytes32' }, {
      'internalType': 'address',
      'name': 'account',
      'type': 'address',
    }], 'name': 'grantRole', 'outputs': [], 'stateMutability': 'nonpayable', 'type': 'function',
  }, {
    'inputs': [{ 'internalType': 'bytes32', 'name': 'role', 'type': 'bytes32' }, {
      'internalType': 'address',
      'name': 'account',
      'type': 'address',
    }],
    'name': 'hasRole',
    'outputs': [{ 'internalType': 'bool', 'name': '', 'type': 'bool' }],
    'stateMutability': 'view',
    'type': 'function',
  }, {
    'inputs': [{ 'internalType': 'address', 'name': 'spender', 'type': 'address' }, {
      'internalType': 'uint256',
      'name': 'addedValue',
      'type': 'uint256',
    }],
    'name': 'increaseAllowance',
    'outputs': [{ 'internalType': 'bool', 'name': '', 'type': 'bool' }],
    'stateMutability': 'nonpayable',
    'type': 'function',
  }, {
    'inputs': [{ 'internalType': 'uint256', 'name': 'amount', 'type': 'uint256' }],
    'name': 'mint',
    'outputs': [{ 'internalType': 'bool', 'name': '', 'type': 'bool' }],
    'stateMutability': 'nonpayable',
    'type': 'function',
  }, {
    'inputs': [{ 'internalType': 'address', 'name': 'receiver', 'type': 'address' }, {
      'internalType': 'uint256',
      'name': 'amount',
      'type': 'uint256',
    }],
    'name': 'mintTo',
    'outputs': [{ 'internalType': 'bool', 'name': '', 'type': 'bool' }],
    'stateMutability': 'nonpayable',
    'type': 'function',
  }, {
    'inputs': [],
    'name': 'name',
    'outputs': [{ 'internalType': 'string', 'name': '', 'type': 'string' }],
    'stateMutability': 'view',
    'type': 'function',
  }, {
    'inputs': [],
    'name': 'owner',
    'outputs': [{ 'internalType': 'address', 'name': '', 'type': 'address' }],
    'stateMutability': 'view',
    'type': 'function',
  }, {
    'inputs': [{ 'internalType': 'bytes32', 'name': 'role', 'type': 'bytes32' }, {
      'internalType': 'address',
      'name': 'account',
      'type': 'address',
    }], 'name': 'renounceRole', 'outputs': [], 'stateMutability': 'nonpayable', 'type': 'function',
  }, {
    'inputs': [{ 'internalType': 'bytes32', 'name': 'role', 'type': 'bytes32' }, {
      'internalType': 'address',
      'name': 'account',
      'type': 'address',
    }], 'name': 'revokeRole', 'outputs': [], 'stateMutability': 'nonpayable', 'type': 'function',
  }, {
    'inputs': [{ 'internalType': 'bytes4', 'name': 'interfaceId', 'type': 'bytes4' }],
    'name': 'supportsInterface',
    'outputs': [{ 'internalType': 'bool', 'name': '', 'type': 'bool' }],
    'stateMutability': 'view',
    'type': 'function',
  }, {
    'inputs': [],
    'name': 'symbol',
    'outputs': [{ 'internalType': 'string', 'name': '', 'type': 'string' }],
    'stateMutability': 'view',
    'type': 'function',
  }, {
    'inputs': [],
    'name': 'totalSupply',
    'outputs': [{ 'internalType': 'uint256', 'name': '', 'type': 'uint256' }],
    'stateMutability': 'view',
    'type': 'function',
  }, {
    'inputs': [{ 'internalType': 'address', 'name': 'recipient', 'type': 'address' }, {
      'internalType': 'uint256',
      'name': 'amount',
      'type': 'uint256',
    }],
    'name': 'transfer',
    'outputs': [{ 'internalType': 'bool', 'name': '', 'type': 'bool' }],
    'stateMutability': 'nonpayable',
    'type': 'function',
  }, {
    'inputs': [{ 'internalType': 'address', 'name': 'sender', 'type': 'address' }, {
      'internalType': 'address',
      'name': 'recipient',
      'type': 'address',
    }, { 'internalType': 'uint256', 'name': 'amount', 'type': 'uint256' }],
    'name': 'transferFrom',
    'outputs': [{ 'internalType': 'bool', 'name': '', 'type': 'bool' }],
    'stateMutability': 'nonpayable',
    'type': 'function',
  }, {
    'inputs': [{ 'internalType': 'address', 'name': 'newOwner', 'type': 'address' }],
    'name': 'transferOwnership',
    'outputs': [],
    'stateMutability': 'nonpayable',
    'type': 'function',
  }];
  const tokenABI2 = [{
    'constant': true,
    'inputs': [],
    'name': 'name',
    'outputs': [{ 'name': '', 'type': 'string' }],
    'payable': false,
    'stateMutability': 'view',
    'type': 'function',
  }, {
    'constant': false,
    'inputs': [{ 'name': '_spender', 'type': 'address' }, { 'name': '_value', 'type': 'uint256' }],
    'name': 'approve',
    'outputs': [{ 'name': '', 'type': 'bool' }],
    'payable': false,
    'stateMutability': 'nonpayable',
    'type': 'function',
  }, {
    'constant': true,
    'inputs': [{ 'name': '_user', 'type': 'address' }],
    'name': 'freezing',
    'outputs': [{ 'name': '', 'type': 'bool' }],
    'payable': false,
    'stateMutability': 'view',
    'type': 'function',
  }, {
    'constant': true,
    'inputs': [],
    'name': 'totalSupply',
    'outputs': [{ 'name': '', 'type': 'uint256' }],
    'payable': false,
    'stateMutability': 'view',
    'type': 'function',
  }, {
    'constant': false,
    'inputs': [{ 'name': '_from', 'type': 'address' }, { 'name': '_to', 'type': 'address' }, {
      'name': '_value',
      'type': 'uint256',
    }],
    'name': 'transferFrom',
    'outputs': [{ 'name': '', 'type': 'bool' }],
    'payable': false,
    'stateMutability': 'nonpayable',
    'type': 'function',
  }, {
    'constant': true,
    'inputs': [],
    'name': 'decimals',
    'outputs': [{ 'name': '', 'type': 'uint256' }],
    'payable': false,
    'stateMutability': 'view',
    'type': 'function',
  }, {
    'constant': false,
    'inputs': [{ 'name': '_user', 'type': 'address' }],
    'name': 'unfreeze',
    'outputs': [{ 'name': '', 'type': 'bool' }],
    'payable': false,
    'stateMutability': 'nonpayable',
    'type': 'function',
  }, {
    'constant': false,
    'inputs': [{ 'name': '_spender', 'type': 'address' }, { 'name': '_subtractedValue', 'type': 'uint256' }],
    'name': 'decreaseApproval',
    'outputs': [{ 'name': '', 'type': 'bool' }],
    'payable': false,
    'stateMutability': 'nonpayable',
    'type': 'function',
  }, {
    'constant': true,
    'inputs': [{ 'name': '_owner', 'type': 'address' }],
    'name': 'balanceOf',
    'outputs': [{ 'name': 'balance', 'type': 'uint256' }],
    'payable': false,
    'stateMutability': 'view',
    'type': 'function',
  }, {
    'constant': false,
    'inputs': [{ 'name': '_user', 'type': 'address' }],
    'name': 'freeze',
    'outputs': [{ 'name': '', 'type': 'bool' }],
    'payable': false,
    'stateMutability': 'nonpayable',
    'type': 'function',
  }, {
    'constant': true,
    'inputs': [],
    'name': 'owner',
    'outputs': [{ 'name': '', 'type': 'address' }],
    'payable': false,
    'stateMutability': 'view',
    'type': 'function',
  }, {
    'constant': true,
    'inputs': [],
    'name': 'symbol',
    'outputs': [{ 'name': '', 'type': 'string' }],
    'payable': false,
    'stateMutability': 'view',
    'type': 'function',
  }, {
    'constant': false,
    'inputs': [{ 'name': '_to', 'type': 'address' }, { 'name': '_value', 'type': 'uint256' }],
    'name': 'transfer',
    'outputs': [{ 'name': '', 'type': 'bool' }],
    'payable': false,
    'stateMutability': 'nonpayable',
    'type': 'function',
  }, {
    'constant': false,
    'inputs': [{ 'name': '_spender', 'type': 'address' }, { 'name': '_addedValue', 'type': 'uint256' }],
    'name': 'increaseApproval',
    'outputs': [{ 'name': '', 'type': 'bool' }],
    'payable': false,
    'stateMutability': 'nonpayable',
    'type': 'function',
  }, {
    'constant': true,
    'inputs': [{ 'name': '_owner', 'type': 'address' }, { 'name': '_spender', 'type': 'address' }],
    'name': 'allowance',
    'outputs': [{ 'name': '', 'type': 'uint256' }],
    'payable': false,
    'stateMutability': 'view',
    'type': 'function',
  }, {
    'constant': false,
    'inputs': [{ 'name': 'newOwner', 'type': 'address' }],
    'name': 'transferOwnership',
    'outputs': [],
    'payable': false,
    'stateMutability': 'nonpayable',
    'type': 'function',
  }, { 'inputs': [], 'payable': false, 'stateMutability': 'nonpayable', 'type': 'constructor' }, {
    'anonymous': false,
    'inputs': [{ 'indexed': true, 'name': 'from', 'type': 'address' }, {
      'indexed': true,
      'name': 'to',
      'type': 'address',
    }, { 'indexed': false, 'name': 'value', 'type': 'uint256' }],
    'name': 'Transfer',
    'type': 'event',
  }, {
    'anonymous': false,
    'inputs': [{ 'indexed': true, 'name': 'owner', 'type': 'address' }, {
      'indexed': true,
      'name': 'spender',
      'type': 'address',
    }, { 'indexed': false, 'name': 'value', 'type': 'uint256' }],
    'name': 'Approval',
    'type': 'event',
  }, {
    'anonymous': false,
    'inputs': [{ 'indexed': true, 'name': 'owner', 'type': 'address' }, {
      'indexed': true,
      'name': 'user',
      'type': 'address',
    }, { 'indexed': false, 'name': 'status', 'type': 'bool' }],
    'name': 'Freeze',
    'type': 'event',
  }, {
    'anonymous': false,
    'inputs': [{ 'indexed': true, 'name': 'previousOwner', 'type': 'address' }, {
      'indexed': true,
      'name': 'newOwner',
      'type': 'address',
    }],
    'name': 'OwnershipTransferred',
    'type': 'event',
  }];
  const [tokenBalance, setTokenBalance] = useState(null);

  return (
    <>
      <li className={`sidebar ${type === 'senior' ? 'sidebar-senior' : ''}`}>
        <div
          className="profile"
          onClick={onToggle}
          id="sidebarMenuLink"
          data-toggle="sidebar"
          aria-haspopup="true"
          aria-expanded="true"
        >
          <span className={account ? 'success' : 'error'} />
          <CustomAccountLogo />
        </div>
        {/*<div className={`sidebar-menu sidebar-menu-right ${toggleClass}`} aria-labelledby="sidebarMenuLink">*/}
        {/*  <div className="close-btn" onClick={onToggle}>*/}
        {/*    ×*/}
        {/*  </div>*/}
        {/*  <div className="avatar item">*/}
        {/*    <div className="icon">*/}
        {/*      <CustomAccountLogo imgStyle={{*/}
        {/*        width: '100%',*/}
        {/*      }} titleStyle={{ fontSize: '24px' }} />*/}
        {/*    </div>*/}
        {/*    <div className="name">{username}</div>*/}
        {/*    /!*<div className="membership">Free Membership</div>*!/*/}
        {/*    /!*{account ? (*!/*/}
        {/*    /!*  <span className="kat">{balance}</span>*!/*/}
        {/*    /!*) : (*!/*/}
        {/*    /!*  userWalletID === 0 ?*!/*/}
        {/*    /!*    <button className="not-login" onClick={() => connectMetamask()}  >*!/*/}
        {/*    /!*      Connect your wallet to see Kat Balance*!/*/}
        {/*    /!*    </button>*!/*/}
        {/*    /!*    :*!/*/}
        {/*    /!*    <p className="WalletDisplay" >*!/*/}
        {/*    /!*      Connected to {userWalletID}*!/*/}
        {/*    /!*    </p>*!/*/}
        {/*    /!*)}*!/*/}
        {/*    /!* <span style={{ color: "white", paddingLeft: "300px" }}> {creditAmount} CREDITS</span> *!/*/}
        {/*    /!*<span className='CreditAmountDisplay'>*!/*/}
        {/*    /!*  {creditAmount} CREDITS {tokenBalance !== null ? "- " + Math.round(tokenBalance) + " KAT" : ""}*!/*/}
        {/*    /!*</span>*!/*/}

        {/*  </div>*/}
        {/*  <div className="pl-0 profile item">*/}
        {/*    <Link to="/user/profile">{I18n.t('my_account')}</Link>*/}
        {/*  </div>*/}
        {/*  <div className="session history item">*/}
        {/*    <Link to="/user/session-history">{I18n.t('session_history')}</Link>*/}
        {/*  </div>*/}
        {/*  /!*<div className="balance item">*!/*/}
        {/*  /!*  <Link to="/user/account-balance">Account Balance</Link>*!/*/}
        {/*  /!*</div>*!/*/}
        {/*  /!*<div className="order-history item">*!/*/}
        {/*  /!*  <Link to="/user/order-history">Order History</Link>*!/*/}
        {/*  /!*</div>*!/*/}
        {/*  /!*<div className="order-history item">*!/*/}
        {/*  /!*  <Link to="/user/nft-licenses">NFT Licenses</Link>*!/*/}
        {/*  /!*</div>*!/*/}
        {/*  /!* <div className="order-history item">*/}
        {/*  <Link to="/user/token-portal">Token Portal</Link>*/}
        {/*</div> *!/*/}
        {/*  <div className="logout item">*/}
        {/*  <span className="sidebar-item logout" onClick={onLogout}>*/}
        {/*    Logout*/}
        {/*  </span>*/}
        {/*  </div>*/}
        {/*</div>*/}
        {/*<div id="overlay" className={toggleClass} onClick={onToggle}></div>*/}
        {
          toggle && (
            <div className="profile_senior">
              <Link to="/user/profile" className="pl-0 d-flex menu-item">
                <div>
                {/*<img src={emptyWallet} alt="emptyWallet" />*/}
                <span className="my_package_name">{I18n.t('my_account')}</span>
                </div>
                <img src={arrowRight2Light} alt="arrowRight2Light" />
              </Link>
              <Link to="/user/session-history" className="pl-0 d-flex menu-item">
                <div>
                  {/*<img src={emptyWallet} alt="emptyWallet" />*/}
                  <span className="my_package_name">{I18n.t('session_history')}</span>
                </div>
                <img src={arrowRight2Light} alt="arrowRight2Light" />
              </Link>
              <div onClick={togglePasswordChangeModal} className="menu-item">
                <div>
                  <img src={passwordChange} alt="passwordChange" />
                  <span className="senior_logout_button">{I18n.t('change_password')}</span>
                </div>
                <img src={arrowRight2Light} alt="arrowRight2Light" />
              </div>
              <div onClick={onLogout} className="menu-item border-0">
                <div>
                  <img src={logout} alt="logout" />
                  <span className="senior_logout_button">{I18n.t('logout')}</span>
                </div>
              </div>
            </div>
          )
        }
        {
          toggleSenior && (
            <div className="profile_senior">
              <Link to="/my-package" className="pl-0 d-flex menu-item">
                <div>
                <img src={emptyWallet} alt="emptyWallet" />
                <span className="my_package_name">{wallet?.package} - {I18n.t('my_package')} </span>
                </div>
                <img src={arrowRight2Light} alt="arrowRight2Light" />
              </Link>
              <div onClick={togglePasswordChangeModal} className="menu-item">
                <div>
                  <img src={passwordChange} alt="passwordChange" />
                  <span className="senior_logout_button">{I18n.t('change_password')}</span>
                </div>
                <img src={arrowRight2Light} alt="arrowRight2Light" />
              </div>
              <div onClick={onLogout} className="menu-item border-0">
                <div>
                  <img src={logout} alt="logout" />
                  <span className="senior_logout_button">{I18n.t('logout')}</span>
                </div>
              </div>
            </div>
          )
        }
      </li>
      <ModalPopup
        size="sm"
        show={passwordChangeModal}
        onHide={togglePasswordChangeModal}
        id="modal-change-password"
        style={{ opacity: 1 }}
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
      >
        <FormSection>
          <div className="d-flex align-items-center justify-content-between mb-4">
            <div className="d-flex align-items-center">
              <img className="cursor-pointer" src={arrowBackIcon} alt="Arrow Back" onClick={changePasswordGoBack} />
              <span className="title">
                {passwordVerify ? I18n.t('change_password_title') : I18n.t('verification_account_by_password')}
              </span>
            </div>
            <span 
              className="cursor-pointer" 
              onClick={togglePasswordChangeModal}
              style={{ fontSize: '24px', fontWeight: 'bold', color: '#666', marginBottom: '-15px !important' }}
            >
              ×
            </span>
          </div>
          <div className="d-flex flex-column mb-3">
            <span className="verify">{passwordVerify ? I18n.t('change_password_des') : I18n.t('verify_password_des')}</span>
            <span className="text-decoration-underline">{user?.email}</span>
          </div>
          <FormField>
            <InputLabel>{passwordVerify ? I18n.t('new_password') : I18n.t('current_password')} <span className="text-danger">*</span></InputLabel>
            <Input
              autoFocus
              placeholder={I18n.t('password_hint')}
              key="password"
              name="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            {passwordError && (
              <span className="error-message">
                <img alt="error" src={warning} style={{ marginTop: '-5px', marginRight: '4px' }} />
                {passwordError}
              </span>
            )}
          </FormField>
          {passwordVerify ?
            <FormField>
              <InputLabel>{I18n.t('confirm_new_password')} <span className="text-danger">*</span></InputLabel>
              <Input
                autoFocus
                placeholder={I18n.t('password_hint')}
                key="password2"
                name="password2"
                type="password"
                value={password2}
                onChange={(e) => setPassword2(e.target.value)}
              />
              {passwordConfirmError && (
                <span className="error-message">
                <img alt="error" src={warning} style={{ marginTop: '-5px', marginRight: '4px' }} />
                  {passwordConfirmError}
              </span>
              )}
            </FormField>
            : null}
          <div onClick={checkPassword} className="verify-submit">{passwordVerify ? I18n.t('change_password_button_title') : I18n.t('verification_account')}</div>
        </FormSection>
      </ModalPopup>
    </>
  );
};

const mapStateToProps = ({ blockchain, user, karma, credit }) => ({ blockchain, user, karma, credit });
const mapDispatchToProps = { verifyBySignIn, connectWallet, watchInfo, logOutMvp, changePassword };

export default connect(mapStateToProps, mapDispatchToProps)(NavProfile);
